<template>
  <button
    class="ri-clothes-button"
    :class="buttonClassObject"
    @click="onClick"
  >
    <transition-group
      name="ri-clothes-ripple"
      @enter="rippleEffectEnter"
      @after-enter="rippleEffectAfterEnter"
    >
      <span
        v-for="i in rippleSpanList"
        class="ri-clothes-ripple"
        :class="rippleClassObject"
        :key="i"
      ></span>
    </transition-group>
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "ri-clothes-button",
  data() {
    return {
      // 生成されたRipple Effect用spanを収納する配列
      rippleSpanList: [],
      // 生成するRipple Effect用spanの大きさ (ターゲットの横幅)
      rippleSize: 0,
      // 最後にクリックした座標 (Ripple Effect用spanの位置に使用)
      lastClickX: 0,
      lastClickY: 0
    };
  },
  props: {
    //ボタンのテキスト
    text: String,
    //ボタンのテキストに使用するカラー
    textColor: {
      textColor: String,
      default: "default"
    },
    buttonType: {
      buttonType: String,
      default: "normal"
    },
    //ボタンのカラー
    color: {
      color: String,
      default: "default"
    },
    //ボタンが無効かどうか
    disable: {
      disable: Boolean,
      default: false
    },
    router_to: {
      router: String,
      default: ""
    },
    href: {
      href: String,
      default: ""
    }
  },
  computed: {
    buttonClassObject: function () {
      let isColorButton = false;
      if(this.color != "default" && this.color != "") {
        isColorButton = true;
      }

      let isTextColor = false;
      if(this.textColor != "default" && this.textColor != "") {
        isTextColor = true;
      }

      let disableCssClass = "ri-clothes-button__disable";
      if(this.buttonType == "text" || this.buttonType == "outline") {
        disableCssClass = "ri-clothes-button--text-button__disable";
      }
      return {
        "ri-clothes-button": this.buttonType == "normal",
        "ri-clothes-button--text-button": this.buttonType == "text",
        "ri-clothes-button--outline-button": this.buttonType == "outline",
        dark: this.$root.config.isDarkTheme,
        [`ri-clothes-button__${this.color}`]: isColorButton,
        [`ri-clothes-button--text-color__${this.textColor}`]: isTextColor,
        [disableCssClass]: this.disable
      };
    },

    rippleClassObject: function() {
      let isColorButton = false;
      let isNormalColorButton = false;
      if(this.color != "default" && this.color != "") {
        if(this.buttonType == "normal") {
          isNormalColorButton = true
        } else {
          isColorButton = true
        }
      }



      return {
        "ri-clothes-ripple__color": isNormalColorButton,
        [`ri-clothes-ripple__${this.color}`]: isColorButton
      }
    }
  },
  methods: {
    rippleEffectEnter: function(event) {
      event.style.top = `${this.lastClickY}px`;
      event.style.left = `${this.lastClickX}px`;
      event.style.width = `${this.rippleSize}px`;
      event.style.height = `${this.rippleSize}px`;
    },
    rippleEffectAfterEnter: function() {
      this.rippleSpanList.shift();
    },
    onClick: function(event) {
      if(this.disable) {
        return;
      }
      const target = event.target;
      const rippleSpanSize = target.offsetWidth;
      const targetLocation = target.getBoundingClientRect();

      const x =
        event.pageX -
        targetLocation.left -
        window.pageXOffset -
        rippleSpanSize / 2;

      const y =
        event.pageY -
        targetLocation.top -
        window.pageYOffset -
        rippleSpanSize / 2;

      this.rippleSize = rippleSpanSize;
      this.lastClickX = x;
      this.lastClickY = y;

      //生成したspanのkey被りを起こさないように乱数をつける
      this.rippleSpanList.push(`ripple-${Math.random()}`);

      this.$emit("onClick");

      if(this.router_to != "") {
        this.$router.push(this.router_to);
      }

      if(this.href != "") {
        window.open(this.href);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ri-clothes-button {
  --button-background-color: var(--buttoon-default-color);
  --button-background-color-rgb: var(--buttoon-default-color-rgb);

  display: inline-block;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  text-decoration: none;
  background-color: var(--button-background-color);
  color: var(--surface-color);
  border: none;
  position: relative;
  overflow: hidden;
  transition: 0.5s;
  margin: 4px;
  border-radius: 4px;

  &__disable {
    --disable-button-color: rgba(0, 0, 0, 0.25);

    --button-background-color: var(--disable-button-color) !important;
  }

  &__red {
    --button-background-color: var(--color-red);
    --button-background-color-rgb: var(--color-red-rgb);
  }
  &__pink {
    --button-background-color: var(--color-pink);
    --button-background-color-rgb: var(--color-pink-rgb);
  }
  &__purple {
    --button-background-color: var(--color-purple);
    --button-background-color-rgb: var(--color-purple-rgb);
  }
  &__deep-purple {
    --button-background-color: var(--color-deep-purple);
    --button-background-color-rgb: var(--color-deep-purple-rgb);
  }
  &__indigo {
    --button-background-color: var(--color-indigo);
    --button-background-color-rgb: var(--color-indigo-rgb);
  }
  &__blue {
    --button-background-color: var(--color-blue);
    --button-background-color-rgb: var(--color-blue-rgb);
  }
  &__light-blue {
    --button-background-color: var(--color-light-blue);
    --button-background-color-rgb: var(--color-light-blue-rgb);
  }
  &__cyan {
    --button-background-color: var(--color-cyan);
    --button-background-color-rgb: var(--color-cyan-rgb);
  }
  &__teal {
    --button-background-color: var(--color-teal);
    --button-background-color-rgb: var(--color-teal-rgb);
  }
  &__green {
    --button-background-color: var(--color-green);
    --button-background-color-rgb: var(--color-green-rgb);
  }
  &__light-green {
    --button-background-color: var(--color-light-green);
    --button-background-color-rgb: var(--color-light-green-rgb);
  }
  &__lime {
    --button-background-color: var(--color-lime);
    --button-background-color-rgb: var(--color-lime-rgb);
  }
  &__yellow {
    --button-background-color: var(--color-yellow);
    --button-background-color-rgb: var(--color-yellow-rgb);
  }
  &__amber {
    --button-background-color: var(--color-amber);
    --button-background-color-rgb: var(--color-amber-rgb);
  }
  &__orange {
    --button-background-color: var(--color-orange);
    --button-background-color-rgb: var(--color-orange-rgb);
  }
  &__deep-orange {
    --button-background-color: var(--color-deep-orange);
    --button-background-color-rgb: var(--color-deep-orange-rgb);
  }
  &__brown {
    --button-background-color: var(--color-brown);
    --button-background-color-rgb: var(--color-brown-rgb);
  }
  &__grey {
    --button-background-color: var(--color-grey);
    --button-background-color-rgb: var(--color-grey-rgb);
  }
  &__blue-grey {
    --button-background-color: var(--color-blue-grey);
    --button-background-color-rgb: var(--color-blue-grey-rgb);
  }

  &--text-color {
    &__white {
      color: #ffffff;
    }

    &__black {
      color: #000000;
    }

    &__reverse {
      color: var(--text-color);
    }
  }

  &--text-button {
    @extend .ri-clothes-button;
    color: var(--button-background-color);
    background-color:rgba(0, 0, 0, 0);
    &:hover {
      background-color: rgba(var(--button-background-color-rgb), 0.15);
    }

    &__disable {
      --disable-button-color: rgba(0, 0, 0, 0.25) !important;

      --button-background-color: var(--disable-button-color);
      &:hover {
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }

  &--outline-button {
    @extend .ri-clothes-button--text-button;
    border: solid 1px var(--button-background-color);
  }
}

.ri-clothes-ripple {
  --ripple-color: var(--text-color);
  display: inline-block;
  position: absolute;
  background-color: var(--ripple-color);
  border-radius: 50%;
  transform: scale(0);
  opacity: 0.18;
  pointer-events: none;

  &__color {
    --ripple-color: var(--surface-color);
  }

  &__red {
    --ripple-color: var(--color-red);
  }
  &__pink {
    --ripple-color: var(--color-pink);
  }
  &__purple {
    --ripple-color: var(--color-purple);
  }
  &__deep-purple {
    --ripple-color: var(--color-deep-purple);
  }
  &__indigo {
    --ripple-color: var(--color-indigo);
  }
  &__blue {
    --ripple-color: var(--color-blue);
  }
  &__light-blue {
    --ripple-color: var(--color-light-blue);
  }
  &__cyan {
    --ripple-color: var(--color-cyan);
  }
  &__teal {
    --ripple-color: var(--color-teal);
  }
  &__green {
    --ripple-color: var(--color-green);
  }
  &__light-green {
    --ripple-color: var(--color-light-green);
  }
  &__lime {
    --ripple-color: var(--color-lime);
  }
  &__yellow {
    --ripple-color: var(--color-yellow);
  }
  &__amber {
    --ripple-color: var(--color-amber);
  }
  &__orange {
    --ripple-color: var(--color-orange);
  }
  &__deep-orange {
    --ripple-color: var(--color-deep-orange);
  }
  &__brown {
    --ripple-color: var(--color-brown);
  }
  &__grey {
    --ripple-color: var(--color-grey);
  }
  &__blue-grey {
    --ripple-color: var(--color-blue-grey);
  }

  &-enter-active {
    animation: ripple--effect-animation 0.8s;
  }
}

.dark {
  --disable-button-color: rgba(255, 255, 255, 0.45) !important;
}

@keyframes ripple--effect-animation {
  to {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
